import React, { Component } from 'react';
import { Card, CardHeader, CardBody, Collapse } from 'reactstrap';


export const AccordionHeader = ({children, ...otherProps }) => (<CardHeader {...otherProps}>
  {children}
</CardHeader>);

export const AccordionBody = ({children, ...otherProps}) => (<Collapse {...otherProps}><CardBody>
  {children}
</CardBody></Collapse>);

export const AccordionItem = ({children, id, isOpen, onClick, ...otherProps}) => (<Card {...otherProps}>
 {React.Children.map(children, (child, index) => {
   if (child.type === AccordionHeader) {
    return React.cloneElement(child, { onClick: onClick(id || index), key: index });
   } else if (child.type === AccordionBody) {
    return React.cloneElement(child, { isOpen, key: index });
   }
   return null;
 })}
</Card>);

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: {}
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle (index) {
    return () => {
      this.setState(state => ({
        open: {
          ...(this.props.multiple?state.open:{}),
          [index] : !state.open[index]
        }
      }));
    }
  }

  render() {
    return (<div className="accordion">
      {React.Children.map(this.props.children, (child, index) => {
        if (child.type !== AccordionItem) return null;
        return React.cloneElement(child, {
          key: index,
          isOpen: child.props.open || !!this.state.open[child.props.id || index],
          onClick: this.toggle,
        })
      })}
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/Accordion.js